import { Component, Input } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
	selector: 'app-truck-summary-report-header',
	templateUrl: './truck-summary-report-header.component.html',
	styleUrls: ['./truck-summary-report-header.component.css']
})
export class TruckSummaryReportHeaderComponent {
	@Input() siteInfo!: any;
	@Input() totalTrucks: number = 0;
	@Input() selectedPeriodFormatted: string = '';
	
	constructor(
		iconRegistry: MatIconRegistry,
		sanitizer: DomSanitizer
	) {
	iconRegistry.addSvgIconLiteral(
		'truck',
		sanitizer.bypassSecurityTrustHtml(`
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
			<path d="M20 8h-3V4H3C1.9 4 1 4.9 1 6v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4z
					M6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z
					M18 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
		</svg>
		`)
	);
	}
}
